export default __webpack_public_path__ + "static/media/no-sos.efb3ec2f.svg";